import { Modal } from "@/components";
import { QuizDto } from "@/types";
import { useState } from "react";
import { MdClose } from "react-icons/md";
import { DoneQuizDetail } from "./DoneQuizDetail";
import { QuizCard } from "./QuizCard";

interface Props {
  quiz: QuizDto;
  trigger?: React.ReactNode;
}

export const DoneQuizModal = ({ quiz, trigger }: Props) => {
  const { id, title, image, marks_obtained, result, total_questions } = quiz;

  const [open, setOpen] = useState(false);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <>
      <div onClick={() => openModal()}>
        {trigger ?? (
          <QuizCard
            id={id}
            title={title}
            coverImage={image}
            score={marks_obtained || 0}
            passed={result === "PASSED"}
            question_count={total_questions || 0}
          />
        )}
      </div>
      {open && (
        <Modal
          open={open}
          onOpenChange={setOpen}
          fullScreen
          overflowScroll={true}
          className="bg-grey-200"
          title={
            <div className="flex gap-2 items-center">
              <button onClick={closeModal}>
                <MdClose className="size-6 text-action_light_active" />
              </button>
              テスト詳細
            </div>
          }
        >
          <DoneQuizDetail
            quiz={{ ...quiz, user_quiz_id: quiz.user_quiz_id }}
            closeModal={closeModal}
          />
        </Modal>
      )}
    </>
  );
};
